import { SEARCH_ALL_METHODS } from 'SearchApp/ts/constants';

export const SEARCH_ALL_PARAMS_STATE_KEYS = ['searchTypes', 'queryInput'];

export const SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY = 'searchAllParams';

export const SEARCH_ALL_PARAMS_SYSTEM_DEFAULT_STATE = {
    searchTypes: SEARCH_ALL_METHODS.map(({ searchMethod }) => searchMethod),
    queryInput: '',
    searchCategoryPageNum: {},
};
